import styled from 'styled-components';

export const Cover = styled.div`
  position: fixed;
  top: ${props => props.top || 0};
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  transform: translateZ(0);
  background-color: rgba(0, 0, 0, 0.5);

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    top 0;
  }
`;

export const Wrapper = styled.div`
  z-index: 11;
  position: relative;
  top: 0;
  left: 0;
  max-width: ${props => (props.customWidth ? props.customWidth : '900')}px;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media screen and (min-width: 500px) {
    left: 50%;
    top: 50%;
    height: auto;
    transform: translate(-50%, -50%);
    max-width: ${props => (props.customWidth ? props.customWidth : 900)}px;
    width: 90%;
    max-height: calc(100% - 1em);
  }
`;

export const Close = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5em;
  line-height: 1;
  background: transparent;
  border: 0;
  box-shadow: 0;
  cursor: pointer;
  z-index: 2;
`;

export const Hide = styled.span`
  border: 0 !important;
  clip: rect(0 0 0 0) !important;
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
`;

export const Icon = styled.svg`
  width: 1.75rem;
  height: 1.75rem;
  fill: transparent;
  stroke: ${props => (props.iconColor ? props.iconColor : 'black')};
  stroke-linecap: round;
  stroke-width: 2;
`;

export const Body = styled.div`
  padding-bottom: ${props => props.bottomSpacing || '1.5rem'};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${props => props.hasHeader && '2.5rem'};
  background-color: white;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  ${props =>
    props.showHeaderShadow && 'box-shadow: 0 0 3px 0px rgba(0,0,0,0.1)'};
`;

export const HeaderTitle = styled.span`
  width: 100%;
  text-align: center;
`;
